// components/WalletForm.js
import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import format from "date-fns/format";
export default function WalletForm({
  subscriptionType,
  expiryDate,
  accountBalance,
  addAmount,
  onChange,
  onSubmit,
  onClear,
}) {
  return (
    <MDBox mt={2} display="flex" flexDirection="column"  gap={2} sx={{ width: "400px" }}>
      <MDInput
        label="Subscription Type"
        name="subscriptionType"
        value={subscriptionType}
        onChange={onChange}
      />

      <MDInput
        label="Expiry Date"
        name="expiryDate"
        value={expiryDate ? format(new Date(expiryDate), "dd/MM/yyyy") : "" }
        onChange={onChange}
      />

      <MDInput
        label="Account Balance"
        name="accountBalance"
        value={accountBalance}
        onChange={onChange}
      />

      <MDInput
        label="Add Amount"
        name="addAmount"
        value={addAmount}
        onChange={onChange}
        placeholder="Enter Amount"
      />

      <MDBox display="flex" justifyContent="space-between">
        <MDButton variant="outlined" color="secondary" onClick={onClear}>
          Clear
        </MDButton>
        <MDButton variant="contained" color="info" onClick={onSubmit}>
          Submit
        </MDButton>
      </MDBox>
    </MDBox>
  );
}